import { PageRef } from 'providers/page-ref';

export type NotificationSettingsPageParams = {};

export const INotificationSettingsPage: PageRef<NotificationSettingsPageParams, void> = {
  pageName: 'NotificationSettingsPage',
} as PageRef<NotificationSettingsPageParams, void>;
